import React, { useEffect, useState } from "react";
import axios from "axios";
import { Parallax } from "react-parallax";
import PdfViewerButton from "../Components/PdfViewerButton";
import LoadingPage from "./LoadingPage";
import { useDocumentMeta } from '../useDocumentMeta';

const MANUAL_PDF_URL = "https://img.0u0.kr/new_port/ctbio_manual.pdf";

function Detail(props) {
  window.scrollTo(0, 0);
  const [detailInfo, setDetailInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetail = async () => {
    try {
      setError(null);
      setDetailInfo(null);
      setLoading(true);
      const response = await axios.get(
        "https://api.0u0.kr/portfolio/detail/Ctbio"
      );
      setDetailInfo(response.data.data);
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetail();
    //
  }, []);
  useDocumentMeta(detailInfo?.pjDetailBigName, detailInfo?.contentHdBgColor);

  if (loading) {
    return (
      <>
        <LoadingPage />
      </>
    );
  }
  if (error) return <div>에러가 발생했습니다.</div>;
  if (!detailInfo) return null;
  if (detailInfo) {
    props.setColorData(detailInfo.contentHdBgColor);
  }

  return (
    <>
      <div
        className="detailHeader"
        style={{ backgroundColor: detailInfo.contentBgColor }}
      >
        <div className="dhTb">
          <div className="dhTbCell">
            <div className="dhDiv">
              <div className="txtBox">
                <h3>{detailInfo.pjDetailSmName}</h3>
                <h1>{detailInfo.pjDetailBigName}</h1>
              </div>
              <div className="logoBox ">
                <div className="logoBoxPt">
                  <img
                    src={"https://img.0u0.kr/new_port/" + detailInfo.imgLogo}
                    alt={detailInfo.pjName + "의 로고"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="whiteBg">
        <div className="detailInfo basicWidth topImgTxtStyle">
          <ul style={{ color: detailInfo.contentFontColor }}>
            <li>
              <div className="tit">카테고리</div>
              <h2>{detailInfo.tagName}</h2>
            </li>

            <li>
              <div className="tit">업무처</div>
              <h2>{detailInfo.teamName}</h2>
            </li>

            <li>
              <div className="tit">기간</div>
              <h2>{detailInfo.pjDate}</h2>
            </li>

            <li>
              <div className="tit">사용 툴/언어</div>
              <h2>{detailInfo.pjTool}</h2>
            </li>
          </ul>
        </div>
      </div>



      <div className="whiteBg">
        <div className="detailInfo basicWidth topImgTxtStyle">
          <div className="basicDetailTitleBox">
            <div className="imgGroupBox mobiCont">
              <img
                src="https://img.0u0.kr/new_port/ctbio001.png"
                className="bdImgBox"
                alt=""
              />
            </div>
            <div className="txtGroupBox ">
              <h2 className="leftAlign">React Native로 제작</h2>
              <div className="txtBox ">
                React Native로 제작되었으나, 안드로이드에 특화되었습니다. 이미지의 위치와 색상을 분석하는 부분은 openCV을 활용하여 안드로이드 플러그인을 직접 제작하여 활용하였습니다.
                <br/>* 동양에스텍과 별도로 따로 업무를 받아 진행한 프로젝트
                <div className="linkBox">
                  <PdfViewerButton
                    url={MANUAL_PDF_URL}
                    label="매뉴얼"
                    style={{backgroundColor:'#000'}}
                  />

                  {/* <a
                    href="https://img.0u0.kr/new_port/ctbio_doc.pdf"
                    rel="noreferrer"
                    target="_blank"
                    style={{backgroundColor:'#000'}}
                  >
                    개발문서
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Detail;
